import { FormOutlined } from '@ant-design/icons';
import { RichTextButton } from '@framework/form';
import { IDropdownClickInfo, SearchableDropdown } from '@framework/ui';
import { Editor } from '@tiptap/react';
import * as React from 'react';
import { useCallback } from 'react';
import {
  ComputeExpressionReferenceAttributes,
  ComputeExpressionReferenceNode,
} from '../../../schema/expressions/compute/input/nodes/ComputeExpressionReferenceNode';
import { IReference } from '../../../schema/expressions/references/IReference';
import { ReferenceBadge } from '../../../schema/expressions/references/display/ReferenceBadge';

export interface IReferenceRichTextButtonProps {
  editor: Editor | null;
  references: IReference[];
}

const filterByCode = (reference: IReference, search?: string) => {
  if (!search) return true;
  return reference.code.toLowerCase().includes(search.toLowerCase());
};

/**
 * Pulsante che permette di inserire un riferimento a una variabile
 * all'interno di un campo di testo.
 */
export function ReferenceRichTextButton(props: IReferenceRichTextButtonProps) {
  const { editor, references } = props;

  const items = useCallback(
    (search?: string) => {
      return references
        .filter(r => r.label !== undefined && filterByCode(r, search))
        .map(r => ({
          key: r.id,
          label: <ReferenceBadge reference={r} />,
          // icon: <ExpressionReferenceIcon reference={r} />
        }));
    },
    [references],
  );

  const handleInsertVariable = useCallback(
    ({ key }: IDropdownClickInfo) => {
      const reference = references.find(r => r.id === key)!;
      editor!
        .chain()
        .focus()
        .insertContent([
          {
            type: ComputeExpressionReferenceNode.name,
            attrs: {
              label: reference.label,
              reference,
              type: reference.field.type,
              id: reference.id,
            } as ComputeExpressionReferenceAttributes,
          },
          // Inseriamo uno spazio per evitare che il cursore si posizioni
          // sul riferimento
          {
            type: 'text',
            text: ' ',
          },
        ])
        .run();
    },
    [editor, references],
  );

  if (!editor) return null;

  return (
    <SearchableDropdown items={items} onClick={handleInsertVariable}>
      <RichTextButton
        onClick={e => e.preventDefault()}
        icon={<FormOutlined />}
        isActive={!!editor.isActive('expressionReference')}
        children="Variabile"
        title="Riferimento a Variabile"
        disabled={!editor.isEditable}
      />
    </SearchableDropdown>
  );
}
